import {
  IconArrowDown,
  IconArrowUp,
  IconCaretDown,
  IconEyeCancel,
} from '@tabler/icons-react';
import { Column } from '@tanstack/react-table';
import { cn } from '../lib/utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './DropdownMenu';
import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
import { Button } from './Button';

// `title` acepta un ReactNode para permitir encabezados sin texto (p. ej. solo
// un icono, cuando el label haría crecer la columna de más). En ese caso el
// nombre legible de la columna sale de `columnDef.meta.header`, que es lo que
// lee el selector de columnas (ColumnsController).
// Se omite el `title` de HTMLAttributes (es `string`, el atributo HTML) para
// poder ensancharlo; los callers que pasan un string siguen compilando igual.
interface DataTableColumnHeaderProps<TData, TValue>
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  column: Column<TData, TValue>;
  title: React.ReactNode;
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>;
  }

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className='h-8 underline-offset-4 flex items-center gap-1 data-[state=open]:underline p-0'>
            <span className='truncate'>{title}</span>
            {column.getIsSorted() === 'desc' ? (
              <ArrowDownIcon className='h-4 w-4' />
            ) : column.getIsSorted() === 'asc' ? (
              <ArrowUpIcon className='h-4 w-4' />
            ) : null}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='start'>
          <DropdownMenuItem onClick={() => column.toggleSorting(false)}>
            <ArrowUpIcon className='mr-2 h-3.5 w-3.5 text-muted-foreground/70' />
            ASC
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => column.toggleSorting(true)}>
            <ArrowDownIcon className='mr-2 h-3.5 w-3.5 text-muted-foreground/70' />
            DESC
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
